<template>
  <div>
    <div class="handle">
      <el-button>批量移除</el-button><el-button>导入名单</el-button
      ><el-button type="primary">名单管理</el-button>
    </div>
    <Table @selection-change="selectChange" :data="persons" row-key="uuid" />
  </div>
</template>

<script>
import Table from "./table.js";
export default {
  components: {
    Table
  },
  props: {
    examQuestionType: {
      type: String,
      default: ""
    },
    personList: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      checkArray: [],
      persons: []
    };
  },
  methods: {
    selectChange(selections) {
      this.checkArray = selections;
    }
  }
};
</script>

<style lang="scss" scoped>
.handle {
  text-align: right;
  margin-bottom: 10px;
}
</style>
